/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FacilityType } from '../../models/facility-type';

export interface UpdateFacilityType$Params {
  facilityTypeId: number;
      body: FacilityType
}

export function updateFacilityType(http: HttpClient, rootUrl: string, params: UpdateFacilityType$Params, context?: HttpContext): Observable<StrictHttpResponse<FacilityType>> {
  const rb = new RequestBuilder(rootUrl, updateFacilityType.PATH, 'put');
  if (params) {
    rb.path('facilityTypeId', params.facilityTypeId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FacilityType>;
    })
  );
}

updateFacilityType.PATH = '/api/facilityType/{facilityTypeId}';
